if (!customElements.get('recipient-form')) {
  customElements.define(
    'recipient-form',
    class RecipientForm extends HTMLElement {
      constructor() {
        super();
        this.recipientFieldsLiveRegion = this.querySelector(`#Recipient-fields-live-region-${this.dataset.sectionId}`);
        this.senderRadioInput = this.querySelector(`#recipient-email-button`);
        this.selfRadioInput = this.querySelector(`#my-email-button`);
        this.selectedOptionDisplay = this.querySelector('.product-selector-label-current-selection-size');
        this.hiddenControlField = this.querySelector(`#Recipient-control-${this.dataset.sectionId}`);
        this.hiddenControlField.disabled = true;
        this.emailInput = this.querySelector(`#Recipient-email-${this.dataset.sectionId}`);
        this.emailError = this.querySelector(`#RecipientForm-email-error-${this.dataset.sectionId}`);
        this.nameInput = this.querySelector(`#Recipient-name-${this.dataset.sectionId}`);
        this.messageInput = this.querySelector(`#Recipient-message-${this.dataset.sectionId}`);
        this.sendonInput = this.querySelector(`#Recipient-send-on-${this.dataset.sectionId}`);
        this.sendonError = this.querySelector(`#RecipientForm-send_on-error-${this.dataset.sectionId}`);
        this.offsetProperty = this.querySelector(`#Recipient-timezone-offset-${this.dataset.sectionId}`);
        if (this.offsetProperty) this.offsetProperty.value = new Date().getTimezoneOffset().toString();
        this.showMessageCheckbox = this.querySelector('#show-gf-message');
        this.messageField = this.querySelector('#gf-message-field');

        this.errorMessageWrapper = this.querySelector('.product-form__recipient-error-message-wrapper');
        this.errorMessageList = this.errorMessageWrapper?.querySelector('ul');
        this.errorMessage = this.errorMessageWrapper?.querySelector('.error-message');
        this.defaultErrorHeader = this.errorMessage?.innerText;
        this.currentProductVariantId = this.dataset.productVariantId;
        this.validationAttempted = false;
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleSubmitClick = this.handleSubmitClick.bind(this);
        this.handleEmailInput = this.handleEmailInput.bind(this);
        this.handleNameInput = this.handleNameInput.bind(this);
        this.handleMessageInput = this.handleMessageInput.bind(this);
        this.handleSendonInput = this.handleSendonInput.bind(this);
        this.toggleMessageField = this.toggleMessageField.bind(this);
        this.addEventListener('change', this.onChange.bind(this));
        this.emailInput?.addEventListener('input', this.handleEmailInput);
        this.nameInput?.addEventListener('input', this.handleNameInput);
        this.messageInput?.addEventListener('input', this.handleMessageInput);
        this.sendonInput?.addEventListener('input', this.handleSendonInput);
        this.sendonDiscalimer = this.querySelector('#informative-date-message');
        this.showMessageCheckbox?.addEventListener('change', this.toggleMessageField);
        this.toggleMessageField();
        this.updateValidIcon(this.emailInput);
        this.updateValidIcon(this.nameInput);
        this.onChange();
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;
      cartErrorUnsubscriber = undefined;
      productForm = undefined;

      connectedCallback() {
        this.productForm = this.closest('form');
        this.productForm?.addEventListener('submit', this.handleFormSubmit, true);
        this.productForm?.addEventListener('click', this.handleSubmitClick, true);

        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (event.source === 'product-form' && event.productVariantId.toString() === this.currentProductVariantId) {
            this.resetRecipientForm();
          }
        });

        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event.data.sectionId === this.dataset.sectionId) {
            this.currentProductVariantId = event.data.variant.id.toString();
          }
        });

        this.cartErrorUnsubscriber = subscribe(PUB_SUB_EVENTS.cartError, (event) => {
          if (event.source === 'product-form' && event.productVariantId.toString() === this.currentProductVariantId) {
            this.displayErrorMessage(event.message, event.errors);
          }
        });
      }

      disconnectedCallback() {
        this.productForm?.removeEventListener('submit', this.handleFormSubmit, true);
        this.productForm?.removeEventListener('click', this.handleSubmitClick, true);

        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }

        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }

        if (this.cartErrorUnsubscriber) {
          this.cartErrorUnsubscriber();
        }
      }

      onChange() {
        const checkedRadio = this.querySelector('input[name="gift_card_send_to_recipient"]:checked');
        const checkedLabel = checkedRadio?.nextElementSibling?.textContent?.trim() || 'selected option';

        if (this.selectedOptionDisplay) {
          this.selectedOptionDisplay.textContent = checkedLabel;
        }

        if (this.senderRadioInput.checked) {
          this.querySelector('.recipient-fields').classList.remove('hidden');
          this.enableInputFields();
          this.recipientFieldsLiveRegion.innerText = window.accessibilityStrings.recipientFormExpanded;

          if (this.validationAttempted) {
            const isEmailValid = this.validateEmail(true, true);
            this.validateSendon(true, isEmailValid);
          }
        } else {
          this.querySelector('.recipient-fields').classList.add('hidden');
          this.validationAttempted = false;
          this.clearInputFields();
          this.disableInputFields();
          this.clearErrorMessage();
          this.recipientFieldsLiveRegion.innerText = window.accessibilityStrings.recipientFormCollapsed;
        }
      }

      inputFields() {
        return [this.emailInput, this.nameInput, this.messageInput, this.sendonInput];
      }

      disableableFields() {
        return [...this.inputFields(), this.offsetProperty, this.hiddenControlField].filter(Boolean);
      }

      clearInputFields() {
        this.inputFields()
          .filter(Boolean)
          .forEach((field) => {
            field.value = '';
            this.updateValidIcon(field);
          });
      }

      enableInputFields() {
        this.disableableFields().forEach((field) => (field.disabled = false));
      }

      disableInputFields() {
        this.disableableFields().forEach((field) => (field.disabled = true));
      }

      toggleMessageField() {
        if (!this.showMessageCheckbox || !this.messageField) return;

        this.messageField.classList.toggle('hidden', !this.showMessageCheckbox.checked);
      }

      handleFormSubmit(event) {
        if (this.validateRecipientFields()) return;

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
      }

      handleSubmitClick(event) {
        const submitButton = event.target?.closest?.('button[type="submit"], button[name="add"]');
        if (!submitButton || !this.productForm?.contains(submitButton)) return;
        if (this.validateRecipientFields()) return;

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
      }

      handleEmailInput() {
        if (!this.senderRadioInput.checked) return;

        this.sanitizeInputValue(this.emailInput);
        this.hideFieldError(this.emailInput, this.emailError);
        this.updateValidIcon(this.emailInput);

        if (!this.emailInput.value.trim()) {
          this.validationAttempted = false;
        }
      }

      handleNameInput() {
        if (!this.senderRadioInput.checked) return;

        this.sanitizeInputValue(this.nameInput);
        this.updateValidIcon(this.nameInput);
      }

      handleMessageInput() {
        if (!this.senderRadioInput.checked) return;

        this.sanitizeInputValue(this.messageInput);
      }

      handleSendonInput() {
        if (!this.senderRadioInput.checked) return;

        this.hideFieldError(this.sendonInput, this.sendonError);

        if (!this.sendonInput.value.trim() && (!this.sendonInput.validity || !this.sendonInput.validity.badInput)) {
          this.validationAttempted = false;
        }
      }

      validateRecipientFields() {
        if (!this.senderRadioInput.checked) {
          this.validationAttempted = false;
          this.clearErrorMessage();
          return true;
        }

        this.validationAttempted = true;
        this.sanitizeRecipientFields();
        const isEmailValid = this.validateEmail(true, true);
        const isSendonValid = this.validateSendon(true, isEmailValid);

        return isEmailValid && isSendonValid;
      }

      sanitizeRecipientFields() {
        [this.emailInput, this.nameInput, this.messageInput].filter(Boolean).forEach((input) => {
          this.sanitizeInputValue(input);
        });
      }

      sanitizeInputValue(input) {
        if (!input || !input.value) return;

        const sanitizedValue = this.stripHtml(input.value);
        if (input.value !== sanitizedValue) {
          input.value = sanitizedValue;
        }
      }

      _giftCardMinSendDate() {
        const today = new Date();
        today.setMinutes(today.getMinutes() - today.getTimezoneOffset());
        return today.toISOString().slice(0, 10);
      }

      stripHtml(value) {
        if (typeof value !== 'string' || !value) return '';

        if (!window.DOMParser) {
          return value.replace(/<[^>]*>/g, '');
        }

        const parsedDocument = new DOMParser().parseFromString(value, 'text/html');
        parsedDocument.querySelectorAll('script, style, template').forEach((element) => element.remove());

        return parsedDocument.body.textContent || '';
      }

      validateEmail(showError = true, shouldScroll = true) {
        if (!this.senderRadioInput.checked) {
          this.hideFieldError(this.emailInput, this.emailError);
          return true;
        }

        const emailValue = this.emailInput.value.trim();
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,63}$/;

        if (emailValue && emailRegex.test(emailValue)) {
          this.hideFieldError(this.emailInput, this.emailError);
          this.updateValidIcon(this.emailInput);
          return true;
        }

        this.updateValidIcon(this.emailInput);

        if (showError) {
          this.showFieldError(this.emailInput, this.emailError, this.dataset.incorrectEmailMsg || '', shouldScroll);
        }

        return false;
      }

      validateSendon(showError = true, shouldScroll = true) {
        if (!this.senderRadioInput.checked) {
          this.hideFieldError(this.sendonInput, this.sendonError);
          return true;
        }

        const sendonValue = this.sendonInput.value.trim();
        const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
        const isBlank = sendonValue === '' && (!this.sendonInput.validity || !this.sendonInput.validity.badInput);
        const minSendOn = this._giftCardMinSendDate();
        const isValid =
          isBlank ||
          (dateRegex.test(sendonValue) && !Number.isNaN(Date.parse(sendonValue)) && sendonValue >= minSendOn);

        if (isValid) {
          this.hideFieldError(this.sendonInput, this.sendonError);
          this.sendonDiscalimer?.classList.remove('hidden');
          return true;
        }

        if (showError) {
          this.showFieldError(this.sendonInput, this.sendonError, this.dataset.incorrectDateMsg || '', shouldScroll);
          this.sendonDiscalimer?.classList.add('hidden');
        }

        return false;
      }

      showFieldError(input, errorElement, message, shouldScroll) {
        if (!input || !errorElement) return;

        errorElement.classList.remove('hidden');
        input.setAttribute('aria-invalid', 'true');
        input.classList.add('form-field__error');

        const errorMessage = errorElement.querySelector('.error-message');
        if (errorMessage && !errorMessage.textContent.trim()) {
          errorMessage.textContent = message.trim();
        }

        if (shouldScroll) {
          errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }

      hideFieldError(input, errorElement) {
        if (!input || !errorElement) return;

        errorElement.classList.add('hidden');
        input.classList.remove('form-field__error');
        input.setAttribute('aria-invalid', 'false');
      }

      updateValidIcon(input) {
        if (!input) return;

        input
          .closest('.form-field')
          ?.classList.toggle('form-field__valid', input.value.trim() !== '' && this.isInputValidForIcon(input));
      }

      isInputValidForIcon(input) {
        if (input === this.emailInput) {
          return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input.value.trim());
        }

        return input.validity.valid;
      }

      displayErrorMessage(title, body) {
        this.clearErrorMessage();
        this.errorMessageWrapper.hidden = false;
        if (typeof body === 'object') {
          this.errorMessage.innerText = this.defaultErrorHeader;
          return Object.entries(body).forEach(([key, value]) => {
            const errorMessageId = `RecipientForm-${key}-error-${this.dataset.sectionId}`;
            const fieldSelector = `#Recipient-${key}-${this.dataset.sectionId}`;
            const message = `${value.join(', ')}`;
            const errorMessageElement = this.querySelector(`#${errorMessageId}`);
            const errorTextElement = errorMessageElement?.querySelector('.error-message');
            if (!errorTextElement) return;

            if (this.errorMessageList) {
              this.errorMessageList.appendChild(this.createErrorListItem(fieldSelector, message));
            }

            errorTextElement.innerText = `${message}.`;
            errorMessageElement.classList.remove('hidden');

            const inputElement = this[`${key}Input`];
            if (!inputElement) return;

            inputElement.setAttribute('aria-invalid', 'true');
            inputElement.setAttribute('aria-describedby', errorMessageId);
          });
        }

        this.errorMessage.innerText = body;
      }

      createErrorListItem(target, message) {
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.setAttribute('href', target);
        a.innerText = message;
        li.appendChild(a);
        li.className = 'error-message';
        return li;
      }

      clearErrorMessage() {
        this.errorMessageWrapper.hidden = true;

        if (this.errorMessageList) this.errorMessageList.innerHTML = '';

        this.querySelectorAll('.recipient-fields .form__message').forEach((field) => {
          field.classList.add('hidden');
          const textField = field.querySelector('.error-message');
          if (textField) textField.innerText = '';
        });

        [this.emailInput, this.messageInput, this.nameInput, this.sendonInput]
          .filter(Boolean)
          .forEach((inputElement) => {
            inputElement.setAttribute('aria-invalid', 'false');
            inputElement.classList.remove('form-field__error');
            inputElement.removeAttribute('aria-describedby');
            this.updateValidIcon(inputElement);
          });
      }

      resetRecipientForm() {
        if (this.senderRadioInput.checked) {
          this.senderRadioInput.checked = false;
          if (this.selfRadioInput) this.selfRadioInput.checked = true;
          this.clearInputFields();
          this.clearErrorMessage();
          this.onChange();
        }
      }
    },
  );
}
